import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import { socialActionsBootstrap } from 'website/bootstrap/socialActionsBootstrap';
import filterList from 'website/containers/lists/filterlist';
import userOpinion from 'website/containers/user-action/UserOpinionBannerEntry';
import userAddToCollection from 'website/containers/user-action/userAddToCollection';
import userRating from 'website/containers/user-action/userRating';
import userReviewLink from 'website/containers/user-action/userReviewLink';
import userWantToSee from 'website/containers/user-action/userWantToSee';
import affinitySuggestions from 'website/containers/user/affinitySuggestions';
import userFriendsRating from 'website/containers/user/userFriendsRating';
import initAnimatedPoster from 'website/module/advertisement/animated-poster';
import initPlayer from 'website/module/player';
import carousel from 'website/module/ui/carousel';
import dropdownLinks from 'website/module/ui/dropdown-custom';
import facebookWidgets from 'website/module/ui/facebookWidgets';
import selectChange from 'website/module/ui/select-change';
import thirdNav from 'website/module/ui/third-nav';

// bootstrap the application / store
applicationBootstrap().then(() => {
  initPlayer();

  carousel();

  thirdNav();

  dropdownLinks();

  filterList();

  selectChange();

  roller();

  // Social user Action
  userOpinion();
  userReviewLink();
  userAddToCollection();
  userFriendsRating();
  facebookWidgets();

  initAnimatedPoster();

  // Social modules based on Redux
  userRating();
  userWantToSee();
  affinitySuggestions();
  socialActionsBootstrap();
});
